import {state as lifecycle} from 'fragments/lifecycle';
import {TABS} from './constants';

export default {
	...lifecycle,
	initialized: false,
	leads: [],
	leadsLoading: true,
	leadsPagination: {},
	leadsQuery: {
		_page: 1,
		tab: TABS.OWN,
		marketingSourceId: null,
		marketingCategoryId: null,
		marketingCustomerTypeId: null,
		phone: null,
		clientName: null,
	},
	leadToDelete: null,
};
